import { handleError } from '../common-message/message-action';
import { API_URL } from '../../../utils/config';
import { makeApiCall } from '../common/common-action';
import { CARD_NUMBER_UPDATED, GET_ADDRESS_CONFIG } from '../../action-contants';

export function getPayeeList(isNiumForexUser = false) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: isNiumForexUser
          ? `${API_URL}/niumForex/remitter/beneficiary`
          : `${API_URL}/remitter/beneficiary-list`,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
export function setCardNumberUpdate(value) {
  return {
    type: CARD_NUMBER_UPDATED,
    value
  };
}

export function getPayeeJSONSchemaByRoutingConfigId(
  formValues,
  payoutSelected,
  routing_config_type
) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        // eslint-disable-next-line max-len
        url: `${API_URL}/remitter/beneficiary/schema?destination_currency=${formValues.currency_code}&destination_country=${formValues.bank_account_country}&beneficiary_account_type=${formValues.account_type}&payout_method=${payoutSelected}&routing_config_type=${routing_config_type}`,
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        return response.data.data;
      }
      return {};
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getPayeeJSONSchemaByCountryCode(
  formValues,
  payout_method,
  beneficiary_country_code,
  routing_config_type
) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        // eslint-disable-next-line max-len
        url: `${API_URL}/remitter/beneficiary/address-schema?beneficiary_country_code=${beneficiary_country_code}&payout_method=${payout_method}&destination_currency=${formValues.currency_code}&routing_config_type=${routing_config_type}`,
        withCredentials: true
      });
      if (response?.data?.success) {
        dispatch({
          type: `${GET_ADDRESS_CONFIG}_SUCCESS`,
          payload: response?.data?.data?.address_details || {}
        });
      } else {
        dispatch({ type: `${GET_ADDRESS_CONFIG}_ERROR` });
      }
      if (response && response.data && response.data.success) {
        return response.data.data;
      }
      return {};
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
